import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

export const KNOWLEDGE_LABELS = {
  profile: 'Profile',
  risk: 'Risk',
  trigger: 'Trigger',
  strategy: 'Strategy',
  safety: 'Safety',
  feeding: 'Feeding',
  sleep: 'Sleep',
  medication: 'Medication',
  preference: 'Preference',
  goal: 'Goal',
  instruction: 'Health & Care',
  support: 'Support',
  contact: 'Contact',
  condition: 'Condition',
  routine: 'Routine',
  baseline: 'Baseline',
  note: 'Note',
  other: 'Other',
};

const PROFILE_CHAPTER_LABELS = Object.freeze({
  person: 'Person',
  communication: 'Communication',
  what_helps: 'What Helps',
  watch_for: 'Watch For',
  daily_life: 'Daily Life',
  safety: 'Safety',
  health_care: 'Health & Care',
});

const getDraftGroup = (draft = {}) => {
  const chapterId = String(
    draft.profileChapterId
    || draft.metadata?.profileChapterId
    || ''
  ).trim().toLowerCase();
  const destinationLabel = PROFILE_CHAPTER_LABELS[chapterId];
  const knowledgeType = draft.knowledgeType || 'other';
  const customLabel = String(draft.customFactType || '')
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());

  return {
    key: destinationLabel ? `${chapterId}:${knowledgeType}` : knowledgeType,
    knowledgeType,
    label: destinationLabel || customLabel || KNOWLEDGE_LABELS[knowledgeType] || KNOWLEDGE_LABELS.other,
  };
};

export const buildDraftsFromSuggestions = (suggestions = []) => suggestions.map((item) => ({
  ...item,
  selected: true,
}));

export const groupDraftsByKnowledgeType = (drafts = []) => {
  const groups = [];
  const groupByType = new Map();

  drafts.forEach((draft) => {
    const groupDetails = getDraftGroup(draft);
    if (!groupByType.has(groupDetails.key)) {
      const group = {
        knowledgeType: groupDetails.knowledgeType,
        label: groupDetails.label,
        drafts: [],
      };
      groupByType.set(groupDetails.key, group);
      groups.push(group);
    }
    groupByType.get(groupDetails.key).drafts.push(draft);
  });

  return groups;
};

export const getReviewHeadline = (drafts = [], source = {}) => {
  const selectedCount = drafts.length;
  const goalCount = drafts.filter((draft) => draft.knowledgeType === 'goal').length;
  const sourceName = source.careDocumentType === 'IEP' || /\biep\b/i.test(source.careDocumentTitle || '')
    ? 'this IEP'
    : 'this source';

  if (selectedCount && selectedCount === goalCount) {
    return `We pulled ${selectedCount} goal${selectedCount === 1 ? '' : 's'} from ${sourceName}`;
  }

  return `We pulled ${selectedCount} care item${selectedCount === 1 ? '' : 's'} from ${sourceName}`;
};

export const getConfidenceTone = (confidence = '') => {
  const normalized = String(confidence || '').toLowerCase();
  if (normalized === 'high') return { bg: '#FFF1EA', color: '#B55334', border: '#F5CFBE' };
  if (normalized === 'medium') return { bg: '#FFF6DD', color: '#B57812', border: '#EBCB82' };
  if (normalized === 'low') return { bg: '#EAF7F2', color: '#4F927E', border: '#C8E6DC' };
  return {
    bg: alpha(colors.semantic.ink, 0.06),
    color: alpha(colors.semantic.ink, 0.66),
    border: alpha(colors.semantic.ink, 0.12),
  };
};

export const reviewTextFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '14px',
    bgcolor: '#FFFFFF',
    '& fieldset': { borderColor: '#DDD4C8', borderWidth: 1.5 },
    '&:hover fieldset': { borderColor: '#CDBFAA' },
    '&.Mui-focused fieldset': { borderColor: colors.brand.deep },
  },
  '& .MuiInputLabel-root': {
    color: alpha(colors.semantic.ink, 0.62),
    fontWeight: 800,
  },
};
